
/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const TransactionReportService = {
  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },
  async getByFeatureCode(featureCode) {
    const requestScreenData = {
      url: `api/TransactionReport('${featureCode}')`,
      top: "1",
      // filter: `ApplicationFeatureCode eq '${featureCode}'`
    };

    return await ApiService.oDataGet(requestScreenData);
  },

//   async getAllRouteOnly() {
//     const requestScreenData = {
//       url: "api/TransactionReport",
//       select: "ApplicationFeatureCode,Route",
//     };

//     return await ApiService.oDataGet(requestScreenData);
//   },
};

export { TransactionReportService };
